<template lang="pug">
v-content
  side-panel(:P='C')

  v-toolbar.page-header(app, flat, fixed, color='white', height='105')
    v-breadcrumbs.ml-0(divider='/')
      v-breadcrumbs-item(disabled='')
        h2.ma-0.mr-3 Inventions
    v-spacer

    v-btn-toggle.mr-5(v-model='inventionsListToggle')
      v-btn(small, flat, @click="seen = !seen")
        | List view
      v-btn(small, flat, @click="seen = !seen")
        | Table view

    v-btn.page-header__action(@click.stop='C.trigger.toggleAddInventionPanel', color='primary')
      | Add Concept

  v-container.pa-0(fluid, grid-list-lg)
    v-layout(row, nowrap)
      v-flex.pr-4
        template(v-if="!seen")
            v-tabs(slider-color='primary', height='45')
                v-tab(@click='C.filters.selected.user_role = null; C.trigger.refreshBaseData({ filters: C.filters.selected });', :ripple='false')
                  | Recent concepts
                v-tab(@click='C.filters.selected.user_role = "inventor"; C.trigger.refreshBaseData({ filters: C.filters.selected });', :ripple='false')
                  | Created by me
                v-tab(@click='C.filters.selected.user_role = "co_inventor"; C.trigger.refreshBaseData({ filters: C.filters.selected });', :ripple='false')
                  | Co-inventing
                v-tab(@click='C.filters.selected.user_role = "mentor"; C.trigger.refreshBaseData({ filters: C.filters.selected });', :ripple='false')
                  | Mentoring
            v-data-iterator.inventions__list( v-bind:items='C.data.inventions', row, wrap, hide-actions)
                v-flex.px-0(slot='item', slot-scope='invention', xs12, sm6, md12)
                    v-card.card--borderless.border--bottom(floating)
                        v-layout(row, no-wrap, align-center)
                            v-flex
                                v-card-title.pa-0.pt-2
                                    h3
                                        a(@click='C.trigger.selectInvention(invention.item)') {{ invention.item.title }}
                                v-card-text.pl-2.pt-2
                                    v-layout(row, wrap, align-center)
                                        p.body-1(v-if='invention.item.role')
                                          v-icon.mr-1(small, color='primary') person
                                          | {{ invention.item.role }}
                                          span.grey--text.px-3 &bull;
                                        p.body-1(v-if="invention.item.phase ? C.dictionary.phase[invention.item.phase] : 'Concept'")
                                          v-icon(small, color='primary') check_circle
                                          | {{ invention.item.phase ? C.dictionary.phase[invention.item.phase] : 'Concept' }}
                                          span.grey--text.px-3 &bull;
                                        p.body-1(v-if='invention.item.opportunity')
                                          v-icon.mr-1(small, color='primary') add_to_photos
                                          | {{ invention.item && invention.item.opportunity && invention.item.opportunity.title }}
                                          span.grey--text.px-3 &bull;
                                        p.body-1
                                          | {{ invention.item.updated_time | moment("MMM D, YYYY") }}

                            v-spacer
                            div.pr-3
                                v-layout(row, no-wrap, justify-end, align-center)
                                    .comment(@click='C.trigger.selectInvention(invention.item, !(invention.item.phase === "phase-2" || invention.item.phase === "phase-3" || invention.item.phase === "phase-4" || invention.item.phase === "phase-5"), "tab-2")', v-if='invention.item.comments_count > 0')
                                        v-icon(medium) chat_bubble
                                        .comment--count.white--text.body-2
                                            | {{ invention.item.comments_count }}
                                    v-btn(flat, icon, color='secondary', @click='C.trigger.selectInvention(invention.item, true)', v-if='(invention.item.phase === "phase-2" || invention.item.phase === "phase-3" || invention.item.phase === "phase-4" || invention.item.phase === "phase-5")')
                                        v-icon mode_edit

        v-data-table(v-if="seen", v-bind:headers='headers', v-bind:items='C.data.inventions', hide-actions, :disable-initial-sort='true', v-infinite-scroll='C.event.extendInventionsList', infinite-scroll-disabled='C.state.infiniteScroll.inventionsList.active', infinite-scroll-throttle-delay='C.state.infiniteScroll.inventionsList.throttle')
          template(slot='items' slot-scope='invention')
            tr
              td
                .comment(@click='C.trigger.selectInvention(invention.item, !(invention.item.phase === "phase-2" || invention.item.phase === "phase-3" || invention.item.phase === "phase-4" || invention.item.phase === "phase-5"), "tab-2")', v-if='invention.item.comments_count > 0')
                  v-icon(medium) chat_bubble
                  .comment--count.white--text.body-2
                    | {{ invention.item.comments_count }}
              td(@click='C.trigger.selectInvention(invention.item)')
                a {{ invention.item.title }}
              td.text-xs-left
                | {{ invention.item.phase ? C.dictionary.phase[invention.item.phase] : 'Concept' }}
              td.text-xs-left
                | {{ invention.item.role }}
              td.text-xs-left
                | {{ invention.item && invention.item.opportunity && invention.item.opportunity.title }}
              td.text-xs-left
                | {{ invention.item.updated_time | moment("MMM D, YYYY") }}
              td.text-xs-right
                v-btn(flat, icon, color='secondary', @click='C.trigger.selectInvention(invention.item, true)', v-if='(invention.item.phase === "phase-2" || invention.item.phase === "phase-3" || invention.item.phase === "phase-4" || invention.item.phase === "phase-5")')
                  v-icon mode_edit

      v-flex(style='position: relative; flex: 0 0 236px')
        .d-block.pt-4(style='width: 220px; position: fixed')
          .body-1.mb-0(style='position: absolute;top: 10px')
            | Narrow Search
          v-text-field.input--box(v-model='C.filters.selected.title', append-icon='search', label='Search', single-line, hide-details)
          v-select.input--box(v-model='C.filters.selected.organization_id', label='All Organizations', v-bind:items='C.filters.list.organizations', item-text='name', item-value='id', :clearable='true', single-line, hide-details, v-if='C.filters.list.organizations.length > 1')
          v-select.input--box(v-model='C.filters.selected.user_role', label='All Roles', v-bind:items='C.filters.list.user_roles', item-text='label', item-value='value', :clearable='true', single-line, hide-details)
          v-select.input--box(v-model='C.filters.selected.phase', label='All Statuses', v-bind:items='C.filters.list.phases', item-text='label', item-value='value', :clearable='true', single-line, hide-details)
          v-layout(row, nowrap)
            v-flex
              v-btn(block, @click='C.trigger.refreshBaseData({ filters: C.filters.selected })')
                | Go
</template>

<script>
  import globalSettings from '../../assets/global-settings.js'
  import tools from '../../assets/tools.js'

  import axios from '../../../node_modules/axios/dist/axios.js'
  import SidePanel from './SidePanel'

  export default {
    components: {
      'side-panel': SidePanel
    },
    data () {
      return {
        seen: false,
        inventionsListToggle: 0,
        headers: [
          {
            text: '',
            align: 'left',
            value: 'comments_count'
          },
          {
            text: 'Name',
            align: 'left',
            value: 'title'
          },
          { text: 'Status', value: 'phase', align: 'left' },
          { text: 'Role', value: 'role', align: 'left' },
          { text: 'Opportunity', value: 'opportunity.title', align: 'left' },
          { text: 'Updated', value: 'updated_time' },
          { text: ' ', value: 'phase' }
        ],
        CR: {
          authorization: globalSettings.authorization,
          show: globalSettings.show
        },
        C: {
          state: {
            sidepanel: {
              tab: 'tab-1'
            },
            list: {
              baseCount: 20
            },
            selected: {
              invention: {
                active: false,
                details: false,
                data: {}
              }
            },
            infiniteScroll: {
              inventionsList: {
                increment: 10,
                throttle: 500,
                active: false,
                lock: false,
                lastCount: -1
              }
            }
          },
          data: {
            inventions: []
          },
          filters: {
            selected: {
              organization_id: null,
              user_role: null,
              phase: null
            },
            list: {
              organizations: [],
              user_roles: [{
                label: 'Inventor',
                value: 'inventor'
              }, {
                label: 'Co-inventor',
                value: 'co_inventor'
              }, {
                label: 'Mentor/Expert',
                value: 'mentor'
              }],
              phases: [{
                label: 'Concept',
                value: 'phase-1'
              }, {
                label: 'Invention Brief',
                value: 'phase-2'
              }, {
                label: 'Invention Full',
                value: 'phase-3'
              }, {
                label: 'Invention Review',
                value: 'phase-4'
              }, {
                label: 'Invention Complete',
                value: 'phase-5'
              }]
            }
          },
          form: {
            selected: {
              invention_id: null,
              invention: {
                title: '',
                description: '',
                search_list: '',
                keywords: '',
                search_results: '',
                action: '',
                action_note: '',
                search: [],
                $search: {
                  title: '',
                  url: '',
                  note: '',
                  tag: ''
                },
                uploaded_filename: '',
                invention_opportunity_id: null,
                organization_id: null,
                bulk_read_access: null
              },
              $collaborator: {
                $item: null,
                access: null
              },
              scratchpad: '',
              co_inventors: [],
              upload: null,
              comments: {
                $list: [],
                content: ''
              }
            },
            trigger: {
              setSelected: (inventionDataItem, targetSidePanelTab) => {
                var component = this

                component.C.state.sidepanel.tab = targetSidePanelTab || 'tab-1'

                if (inventionDataItem) {
                  component.C.form.selected.invention_id = inventionDataItem.id
                  component.C.form.selected.invention.title = inventionDataItem.title
                  component.C.form.selected.invention.description = inventionDataItem.description
                  component.C.form.selected.invention.search_list = inventionDataItem.search_list || ''
                  component.C.form.selected.invention.keywords = inventionDataItem.keywords || ''
                  component.C.form.selected.invention.search_results = inventionDataItem.search_results || ''
                  component.C.form.selected.invention.action = inventionDataItem.action
                  component.C.form.selected.invention.action_note = inventionDataItem.action_note
                  component.C.form.selected.invention.search = inventionDataItem.searches // ### Incomplete
                  component.C.form.selected.invention.uploaded_filename = inventionDataItem.uploaded_filename

                  var targetOpportunityID = (inventionDataItem.opportunity && inventionDataItem.opportunity.id)
                  if (targetOpportunityID === -1) {
                    component.C.form.selected.invention.invention_opportunity_id = '$other'
                  } else {
                    component.C.form.selected.invention.invention_opportunity_id = targetOpportunityID
                  }

                  component.C.form.selected.invention.organization_id = (inventionDataItem.organization && inventionDataItem.organization.id)
                  component.C.form.selected.invention.bulk_read_access = inventionDataItem.bulk_read_access || null
                  component.C.form.selected.scratchpad = (inventionDataItem.scratchpad && inventionDataItem.scratchpad.content) || ''

                  component.C.form.selected.co_inventors = []

                  for (var i = 0; i < inventionDataItem.co_inventors.length; i++) {
                    component.C.form.selected.co_inventors.push({
                      $name: `${inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.firstname} ${inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.lastname}`,
                      user_id: inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.id,
                      access: inventionDataItem.co_inventors[i].access
                    })
                  }

                  component.C.form.selected.comments.$list = inventionDataItem.comments
                } else {
                  component.C.form.selected.invention_id = null
                  component.C.form.selected.invention.title = ''
                  component.C.form.selected.invention.description = ''
                  component.C.form.selected.invention.search_list = ''
                  component.C.form.selected.invention.keywords = ''
                  component.C.form.selected.invention.search_results = ''
                  component.C.form.selected.invention.action = ''
                  component.C.form.selected.invention.action_note = ''
                  component.C.form.selected.invention.search = []
                  component.C.form.selected.invention.$search.title = ''
                  component.C.form.selected.invention.$search.url = ''
                  component.C.form.selected.invention.$search.note = ''
                  component.C.form.selected.invention.$search.tag = ''
                  component.C.form.selected.invention.uploaded_filename = ''
                  component.C.form.selected.invention.invention_opportunity_id = null
                  component.C.form.selected.invention.organization_id = null
                  component.C.form.selected.invention.bulk_read_access = null
                  component.C.form.selected.scratchpad = ''

                  component.C.form.selected.co_inventors = []

                  component.C.form.selected.comments.$list = []
                }

                component.C.form.selected.$collaborator.$item = null
                component.C.form.selected.$collaborator.access = null
                component.C.form.selected.upload = null

                component.C.form.error.active = false
                component.C.form.error.type = null
              }
            },
            error: {
              active: false,
              type: null
            }
          },
          trigger: {
            refreshBaseData: (options) => {
              var component = this

              axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/list`, {
                params: {
                  page: 1,
                  size: component.C.state.list.baseCount,
                  title: component.C.filters.selected.title,
                  organization_id: component.C.filters.selected.organization_id,
                  user_role: component.C.filters.selected.user_role,
                  phase: component.C.filters.selected.phase,
                  sort_column: 'updated_time',
                  sort_order: 'desc'
                }
              })
                   .then(response => {
                     var inventionsList = (response && response.data && response.data.data && response.data.data.inventions) || []

                     component.C.data.inventions = inventionsList

                     component.C.state.infiniteScroll.inventionsList.active = false

                     if (inventionsList.length === component.C.state.infiniteScroll.inventionsList.lastCount) {
                       component.C.state.infiniteScroll.inventionsList.lock = true
                     } else {
                       component.C.state.infiniteScroll.inventionsList.lastCount = inventionsList.length
                     }

                     console.info('component.C.data.inventions', component.C.data.inventions)
                   })
                   .catch(errorResponse => {
                     tools.alert({
                       type: 'error',
                       errorResponse: errorResponse
                     })
                   })
            },
            toggleAddInventionPanel: () => {
              var component = this

              component.C.form.trigger.setSelected()

              component.C.state.selected.invention.active = !component.C.state.selected.invention.active
              component.C.state.selected.invention.details = false
            },
            selectInvention: (invention, forceSidePanel, targetSidePanelTab) => {
              var component = this

              if ((invention.phase === 'phase-2' || invention.phase === 'phase-3' || invention.phase === 'phase-4' || invention.phase === 'phase-5') && !forceSidePanel) {
                component.$router.push({
                  name: 'InventionSolution',
                  params: {
                    id: invention.id
                  }
                })
              } else {
                axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/detail`, {
                  params: {
                    invention_id: invention.id
                  }
                })
                     .then(response => {
                       var inventionItem = (response && response.data && response.data.data && response.data.data.invention) || {}
                       var isEditable = (response && response.data && response.data.data && response.data.data.is_editable) || false

                       component.C.form.trigger.setSelected(inventionItem, targetSidePanelTab)

                       component.C.state.selected.invention.active = true
                       component.C.state.selected.invention.details = true
                       component.C.state.selected.invention.data = inventionItem
                       component.C.state.selected.invention.isEditable = isEditable
                     })
                     .catch(errorResponse => {
                       tools.alert({
                         type: 'error',
                         errorResponse: errorResponse
                       })
                     })
              }
            }
          },
          event: {
            extendInventionsList: () => {
              var component = this

              if (!component.C.state.infiniteScroll.inventionsList.lock) {
                component.C.state.infiniteScroll.inventionsList.active = true

                component.C.state.list.baseCount += component.C.state.infiniteScroll.inventionsList.increment
                component.C.trigger.refreshBaseData()
              }
            }
          },
          dictionary: {
            phase: {
              'phase-1': 'Concept',
              'phase-2': 'Invention Brief',
              'phase-3': 'Invention Full',
              'phase-4': 'Invention Review',
              'phase-5': 'Invention Complete'
            }
          }
        }
      }
    },
    created () {
      var component = this

      component.C.trigger.refreshBaseData()
    }
  }
</script>


<style scoped lang="scss">

.side-drawer {
  background-color: transparent;
}
.comment {
  position: relative;
  &--count {
    position: absolute;
    top: 1px;
    font-weight: 700;
    width: 28px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Inventions/Inventions.vue